// extracted by mini-css-extract-plugin
module.exports = {"container":"ChromeExtensionSidePanelToggle_container__gUbst","button":"ChromeExtensionSidePanelToggle_button__z54ww"};